import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '@app/material.module';
import { LoaderComponent } from './loader/loader.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MapMarkerListComponent } from './components/map-marker-list/map-marker-list.component';
import { SearchFieldComponent } from './components/search-field/search-field.component';
import { CardImagesComponent } from './components/card-images/card-images.component';
import { FiltersComponent } from './components/filters/filters.component';
import { GalleryComponent } from '@shared/components/gallery/gallery.component';
import { NearbyPoiComponent } from '@app/@shared/components/nearby-poi/nearby-poi.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

@NgModule({
  imports: [
    FlexLayoutModule,
    MaterialModule,
    CommonModule,
    ScrollingModule,
    RouterModule,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    NgxSliderModule,
  ],
  declarations: [
    LoaderComponent,
    MapMarkerListComponent,
    SearchFieldComponent,
    CardImagesComponent,
    FiltersComponent,
    GalleryComponent,
    NearbyPoiComponent,
  ],
  exports: [
    LoaderComponent,
    MapMarkerListComponent,
    SearchFieldComponent,
    CardImagesComponent,
    FiltersComponent,
    NearbyPoiComponent,
  ],
})
export class SharedModule {}
